import {
  PROFILE_LOADING,
  PROFILE_SET_DATA,
  PROFILE_SET_DATA_ERROR,
  PROFILE_EDIT_START,
  PROFILE_EDIT_SUCCESS,
  PROFILE_EDIT_FAILURE,
  GET_OTHER_PROFILE_START,
  GET_OTHER_PROFILE_SUCCESS,
  GET_OTHER_PROFILE_FAILURE
} from "./constants";
import { _fetchProfile, _updateProfileDetails, _fetchOtherProfile } from "./services";
import { errorParser } from '../../services/apiErrorParser';

export function profileSetLoading(loading) {
  return {
    type: PROFILE_LOADING,
    payload: loading,
  };
}

export function profileSetData(data) {
  return {
    type: PROFILE_SET_DATA,
    payload: data,
  };
}

export function profileSetDataError(error) {
  return {
    type: PROFILE_SET_DATA_ERROR,
    payload: error,
  };
}

export const editProfileStart = (data) => {
  return {
    type: PROFILE_EDIT_START,
    payload: data,
  };
};

export const editProfileSuccess = (data) => {
  return {
    type: PROFILE_EDIT_SUCCESS,
    payload: data,
  };
};

export const editProfileFailure = (error) => {
  return {
    type: PROFILE_EDIT_FAILURE,
    payload: error,
  };
};

const getOtherProfileStart = data => {
  return {
    type: GET_OTHER_PROFILE_START,
    payload: data,
  };
}
const getOtherProfileSuccess = data => {
  return {
    type: GET_OTHER_PROFILE_SUCCESS,
    payload: data,
  };
}
const getOtherProfileFailure = error => {
  return {
    type: GET_OTHER_PROFILE_FAILURE,
    payload: error,
  };
}

export const fetchProfile = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(profileSetLoading(true));
    _fetchProfile()
      .then(async (res) => {
        await dispatch(profileSetData(res));
        resolve(res);
      })
      .catch(async(err) => {
        const parsedError = await errorParser.parseError(err)
		    dispatch(profileSetDataError(parsedError));
        reject(err);
      })
  });
};

export const fetchOtherProfile = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(getOtherProfileStart(true));
    _fetchOtherProfile(id)
      .then(async (res) => {
        await dispatch(getOtherProfileSuccess(res));
        resolve(res);
      })
      .catch(async(err) => {
        const parsedError = await errorParser.parseError(err)
		    dispatch(getOtherProfileFailure(parsedError));
        reject(err);
      })
  });
};

export const updateProfile = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(editProfileStart(true));
    _updateProfileDetails(data)
      .then(async (res) => {
        await dispatch(editProfileSuccess(res));
        resolve(res);
      })
      .catch(async(err) => {
		const parsedError = await errorParser.parseError(err)
		dispatch(editProfileFailure(parsedError));
        reject(err);
      })
  });
};
